import React from 'react';
import { Container, Row, Col } from "react-bootstrap";
import './EstandarPortalWeb.css';
import botones from './img/botones.png';
import colores from './img/colores.png';
import footer from './img/footer.png';
import iconografia from './img/iconografia.png';
import menu from './img/menu.png';
import separadores from './img/separadores.png';
import tipografia from './img/tipografia.png';
import tablas from './img/tablas.png';
import noticias from './img/noticias.png';
import etc from './img/etc.png';
import transparencia from './img/transparencia.png'
import { Link as ScrollLink } from 'react-scroll';




const EstandarPortalWeb = () => {
    return (
        <Container className="margin-x-15">
            <Row>
                <Col xs={12} md={3} className="left-col">
                    {/* Aquí va tu sidepanel */}
                    <div className="contenedor-seccion">
                        <Container className="sidepanel">
                            <ul style={{padding:0}}>
                                <li><ScrollLink className="title side-enlace" to="introduccion" smooth={true} duration={500}>Introducción</ScrollLink>
                                    <ul>
                                        <li><ScrollLink className="side-enlace" to="introduccion" smooth={true} duration={500}>Introducción</ScrollLink></li>
                                        <li><ScrollLink className="side-enlace" to="documento" smooth={true} duration={500}>Documento</ScrollLink></li>
                                        <li><ScrollLink className="side-enlace" to="tecnologia" smooth={true} duration={500}>Tecnología</ScrollLink></li>
                                    </ul>
                                </li>
                                <li><div className="divider left"></div></li>

                                <li><ScrollLink className="title side-enlace" to="gettingstarted" smooth={true} duration={500}>Paleta de colores</ScrollLink>
                                    <ul>
                                        <li><ScrollLink className="side-enlace" to="tipografia" smooth={true} duration={500}>Tipografía</ScrollLink></li>
                                        <li><ScrollLink className="side-enlace" to="colores" smooth={true} duration={500}>Colores</ScrollLink></li>
                                    </ul>
                                </li>
                                <li><div className="divider left"></div></li>

                                <li><ScrollLink className="title side-enlace" to="Componentes" smooth={true} duration={500}>Componentes</ScrollLink>
                                    <ul>
                                        <li><ScrollLink className="side-enlace" to="Menu" smooth={true} duration={500}>Menu (encabezado)</ScrollLink></li>
                                        <li><ScrollLink className="side-enlace" to="Footer" smooth={true} duration={500}>Footer</ScrollLink></li>
                                        <li><ScrollLink className="side-enlace" to="Botones" smooth={true} duration={500}>Botones</ScrollLink></li>
                                        <li><ScrollLink className="side-enlace" to="Iconos" smooth={true} duration={500}>Iconografía</ScrollLink></li>
                                        <li><ScrollLink className="side-enlace" to="Separadores" smooth={true} duration={500}>Separadores</ScrollLink></li>
                                        <li><ScrollLink className="side-enlace" to="Tablas" smooth={true} duration={500}>Tablas</ScrollLink></li>
                                    </ul>
                                </li>
                                <li><div className="divider left"></div></li>

                                <li><ScrollLink className="title side-enlace" to="Secciones" smooth={true} duration={500}>Secciones</ScrollLink>
                                    <ul>
                                        <li><ScrollLink className="side-enlace" to="Secciones" smooth={true} duration={500}>Noticias</ScrollLink></li>
                                        <li><ScrollLink className="side-enlace" to="Secciones" smooth={true} duration={500}>Transparencia</ScrollLink></li>
                                        <li><ScrollLink className="side-enlace" to="Secciones" smooth={true} duration={500}>Avisos, anuncios, convocatorias, etc</ScrollLink></li>
                                    </ul>
                                </li>
                            </ul>
                        </Container>
                    </div>
                </Col>
                <Col xs={12} md={9} className="right-col">
                    {/* Aquí va el contenido principal */}
                    <div className="contenedor-seccion">
                        <h1 className="portal-header" id="introduccion">Introducción</h1>

                        <p>
                            Portal informativo sobre los lineamientos de diseño y comunicación para las páginas web de Baja California. En este documento, encontrarás las normas y recomendaciones que debes seguir para crear una página web atractiva, funcional y accesible que refleje la identidad y los valores de Baja California.
                        </p>


                        <h2 id="documento">Documento</h2>

                        <a href="https://drive.google.com/uc?export=download&id=1XEYk0DkEFBLtTe1_Km6BgPRtxHG5YFmh"
                           download>Lineamientos_Portales.pdf </a>


                    </div>

                    <div className="divider" style={{width: "24%", margin: "30px 0"}}></div>

                    <div className="contenedor-seccion">
                            {/* ... Todos los otros elementos HTML convertidos a JSX */}
                        <h2 id="tipografia"> Tipografía </h2>

                            <p id=""><b>Importante:</b> </p>
                            <ul>
                                <li>Montserrat</li>
                                <li>No utilizar Italica</li>
                                <li>Textos en mayúsculas y minúsculas en los títulos</li>
                            </ul>


                            <p style={{ fontWeight: 800, color: "#6a1c32" }}>ExtraBold</p>
                            <p style={{ fontWeight: 700, color: "#6a1c32" }}>Bold</p>
                            <p style={{ fontWeight: 500, color: "#6a1c32" }}>Medium</p>
                            <p style={{ fontWeight: 400, color: "#6a1c32" }}>Regular</p>


                            <img src={tipografia} id="" alt="tipografia de paginas baja california" className="img-fluid"/>

                           <h2 id="colores"> Colores </h2>

                            <p> RGB y Digital se pueden utilizar las gamas bajas de los mismos colores</p>

                            <img src={colores} id="" alt="Colores para portal de paginas" className="img-fluid"/>

                        </div>

                    <div className="divider" style={{width: "24%", margin: "30px 0"}}></div>

                    <div className="contenedor-seccion">
                        <h1 className="portal-header" id="Componentes">Componentes</h1>

                    <h2 id="Menu">Menu</h2>
                    <p className="breadcrumb">Selección de opciones en el menú - BREADCRUB (color #6A1C32).</p>
                    <p className="tab-option">Selección de pestañas en las opciones (color #FFFFFF).</p>
                    <p>Diseño de menú para todas las páginas de gobierno, solo cambian los logotipos.</p>
                    <p>Barra de iconos de redes sociales y contacto.</p>
                    <img src={menu} className="img-fluid" alt="encabezado paginas de gobierno baja california" />

                    <h2 id="Footer">Footer</h2>
                    <p>Fondo (color #3F3F3D).</p>
                    <p>Barra (color #6A1C32).</p>
                    <p>Línea (color #B17A45).</p>
                    <p>Logotipo del Gobierno del Estado versión vertical para fondo oscuro.</p>
                    <p>El menu del footer debe destacar las opciones principales del sitio.</p>
                    <img src={footer} className="img-fluid" alt="footer paginas de gobierno de baja california" />

                    <h2 id="Botones">Botones</h2>
                    <p>Fondo (color #F8F8F8).</p>
                    <p>Tipografía (color #6A1C32).</p>
                    <p>Línea (color #6A1C32).</p>
                    <img src={botones} className="img-fluid" alt="Botones para portales web del estado de baja california" />

                    <h2 id="Iconos">Iconografía</h2>
                    <p>Se pueden descargar desde flaticon.com</p>
                    <img src={iconografia} className="img-fluid" alt="Iconografía de paginas web de baja california" />

                    <h2 id="Separadores">Separadores</h2>

                    <p>Color #E0E0E0</p>
                    <p>Linea</p>
                    <p>Recuadro</p>
                    <p>Combinación de fondos</p>


                    <img src={separadores} className="img-fluid" alt="Separadores para portales web del estado de baja california" />

                    <h2 id="Tablas">Tablas</h2>

                    <img src={tablas} className="img-fluid" alt="Formato de tablas para portales web del estado de baja california" />

                </div>

                <div className="divider" style={{width: "24%", margin: "30px 0"}}></div>
                <div className="contenedor-seccion">

                        <h1 className="portal-header" id="Secciones">SECCIONES</h1>

                        <h2 id="Noticias">NOTICIAS</h2>
                        <img src={noticias} className="img-fluid" alt="Formato de tablas para portales web del estado de baja california" />

                        <h2 id="Transparencia">TRANSPARENCIA</h2>
                        <img src={transparencia} className="img-fluid" alt="Formato de tablas para portales web del estado de baja california" />

                        <h2 id="Etc">AVISOS, ANUNCIOS , CONVOCATORIAS , ETC </h2>
                        <img src={etc} className="img-fluid" alt="Formato de tablas para portales web del estado de baja california" />

                    </div>

                </Col>
            </Row>

        </Container>
    )
}

export default EstandarPortalWeb
